var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1033 2.61362C13.4701 1.87037 14.5299 1.87037 14.8967 2.61362L17.8818 8.66207C18.0275 8.95721 18.3091 9.16178 18.6348 9.20911L25.3096 10.179C26.1298 10.2982 26.4574 11.3062 25.8638 11.8847L21.0339 16.5928C20.7982 16.8225 20.6906 17.1535 20.7463 17.4779L21.8865 24.1258C22.0266 24.9427 21.1691 25.5657 20.4355 25.18L14.4653 22.0413C14.174 21.8881 13.826 21.8881 13.5347 22.0413L7.56448 25.18C6.83085 25.5657 5.97342 24.9427 6.11353 24.1258L7.25373 17.4779C7.30937 17.1535 7.20182 16.8225 6.96614 16.5928L2.13616 11.8847C1.54264 11.3062 1.87015 10.2982 2.69037 10.179L9.36524 9.20911C9.69095 9.16178 9.97251 8.95721 10.1182 8.66207L13.1033 2.61362Z",
    fill: "#F38500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d1962ad328cb0081f474c0ac6cd0505d.svg";
export { ForwardRef as ReactComponent };